export default __webpack_public_path__ + "static/media/cloud-computing.78f47282.svg";